import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdministrationComponent } from './administration.component';
import { FunctionMasterComponent } from './function-master/function-master.component';
import { ComponentMasterComponent } from './component-master/component-master.component';
import { RegulatoryGroupMasterComponent } from './regulatory-group-master/regulatory-group-master.component';
import { ViewGroupComponent } from './regulatory-group-master/view-group/view-group.component';
import { PropertyMasterComponent } from './property-master/property-master.component';
import { LeadContactsManagementComponent } from './lead-contacts-management/lead-contacts-management.component';
import { SelfAssessmentComponent } from './self-assessment/self-assessment.component';
import { MarketMasterComponent } from './market-master/market-master.component';

const routes: Routes = [
  {
    path: '',
    component: AdministrationComponent,
    children: [
      {
        path: 'component-master',
        component: ComponentMasterComponent
      },
      {
        path: 'function-master',
        component: FunctionMasterComponent
      },
      {
        path: 'regulatory-group-master/view-group/:id',
        component: ViewGroupComponent
      },
      {
        path: 'regulatory-group-master',
        component: RegulatoryGroupMasterComponent,
        pathMatch: 'full'
      },
      {
        path: 'property-master',
        component: PropertyMasterComponent
      },
      {
        path: 'lead-contacts-management',
        component: LeadContactsManagementComponent
      },
      {
        path: 'self-assessment',
        component: SelfAssessmentComponent
      },
      {
        path: 'market-master',
        component: MarketMasterComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdministrationRoutingModule { }
